export default __webpack_public_path__ + "static/media/banner-image.65f8a92c.jpg";